module.exports = __webpack_public_path__ + "tanzania.svg?7f8345f85324af48af43cb6e9c96fb03";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/tanzania.svg
// module id = 315
// module chunks = 10